<template>
  <div>
    <div class="container">
      <header class="blog-header py-3">
        <div class="row flex-nowrap justify-content-between align-items-center">
          <div class="col-md-6 col-sm-12 text-left">
            <div class="d-flex align-items-center">
              <img src="./assets/logo.png" class="mr-3" width="100" height="60" alt="">
              <span class="portal-header-logo font-sj" href="#">母爱圣地 幸福乳山</span>
            </div>
          </div>
        </div>
      </header>
      <div class="hehe bg-white rounded px-3 mb-3">
        <div class="nav-scroller py-1 mb-2">
          <nav class="nav d-flex justify-content-between">
            <router-link class="p-2 text-muted" :to="{name: 'Home'}">乳山</router-link>
            <router-link class="p-2 text-muted" :to="{name: 'Towns'}">乡镇</router-link>
            <a class="p-2 text-muted" href="#">风土</a>
            <a class="p-2 text-muted" href="#">地理</a>
            <a class="p-2 text-muted" href="#">回忆</a>
            <a class="p-2 text-muted" href="#">旅游</a>
            <a class="p-2 text-muted" href="#">大乳山</a>
            <a class="p-2 text-muted" href="#">银滩</a>
            <a class="p-2 text-muted" href="#">小吃・炸甩</a>
            <a class="p-2 text-muted" href="#">人文</a>
            <a class="p-2 text-muted" href="#">文章</a>
            <a class="p-2 text-muted" href="#">联系我们</a>
            <a class="p-2 text-muted" href="#">关于</a>
          </nav>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
.portal-header-logo {
  font-size: 1.5em;
}
/* .hehe {
  border: 10px solid transparent;
  border-image-source: url(./assets/border.png);
  border-image-width: 400 400;
  border-image-repeat: stretch stretch;
  border-image-slice: 750;
}
.hehe {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.nav-scroller {
  margin: 0px !important;
} */
</style>
